module.exports = __webpack_public_path__ + "static/media/vitejs.6bf1686c.svg";